<template>
    <div v-if="notification" class="board-container" data-aos="fade-up" data-aos-delay="100">
        <v-row align="center" class="row--xs">
            <v-col cols="auto">
                <v-chip small outlined color="secondary" class="font-weight-extrabold">
                    <v-icon color="primary" class="font-size-14 mr-4px">mdi-alert-circle</v-icon>
                    <span>{{ notification.category }}</span>
                </v-chip>
            </v-col>
            <v-col>
                <h5 class="tit tit--xxs">{{ notification.subject }}</h5>
            </v-col>
        </v-row>
        <table class="board-view mt-12px mt-md-20px">
            <tr>
                <td colspan="2">
                    <!-- <span>작성자 : 관리자</span> &nbsp;&nbsp;&nbsp; -->
                    <v-row class="row--small">
                        <v-col cols="auto">
                            <span>작성일 : {{ notification.createdAt.toDate() }}</span>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="auto">
                            <v-layout align-center>
                                <i class="icon icon-view mr-4px" />
                                {{ notification.viewCount }}
                            </v-layout>
                        </v-col>
                    </v-row>
                </td>
            </tr>
            <tr v-if="notification.uploads">
                <td colspan="2">
                    <v-layout align-center>
                        <span class="mr-10px">첨부파일</span>
                        <v-row class="row--xxs">
                            <v-col v-for="upload, index in notification.uploads" :key="index" cols="auto">
                                <v-chip x-small color="grey lighten-5" class="grey--text" @click="download(upload.src, upload.name)">
                                    {{ upload.name.split('/').pop() }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-layout>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="content_box">
                    <div v-html="notification.content.replace(/\n/g,'<br>')"></div>
                </td>
            </tr>
        </table>

        <table v-show="false" class="board-view-navi">
            <tr>
                <th width="20%">이전글</th>
                <td><a href="">이전 게시글 제목입니다.</a></td>
            </tr>
            <tr>
                <th width="20%">다음글</th>
                <td><a href="">다음 게시글 제목입니다.</a></td>
            </tr>
        </table>

        <v-layout justify-end class="mt--md">
            <v-btn outlined color="grey lighten-3" @click="$router.go(-1)"><span class="grey--text">리스트</span></v-btn>
        </v-layout>

        <div class="mt-20 mt-md-30">
            <div v-show="false" class="v-btn--group justify-end">
                <v-btn large color="primary">수정</v-btn>
                <v-btn large outlined color="primary">삭제</v-btn>
                <v-btn large outlined color="primary" class="grey-2--text">답글</v-btn>
            </div>
            <!-- <div class="v-btn--group justify-end">
                <v-btn @click="$router.go(-1)" large color="primary">리스트</v-btn>
            </div> -->
        </div>
    </div>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

export default {
	components: {
	},
    data() {
        return {
            notification: null
        };
    },
	mounted() {
		this.init();
	},
	methods: {
        download: (url, name) => api.resource.get(url).then(file => download(file, name)),
		async init() {
            try{
                var { notification } = await api.v1.center.notifications.get({ _id: this.$route.params._notification });
                if(notification.upload) notification.upload = await api.getResource(notification.upload);
                this.notification = notification;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
		}
	},
}
</script>
